import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../Button/Button';
import styles from './RecordClipTrigger.module.scss';
import cx from 'classnames';
import TooltipButton from '../TooltipButton/TooltipButton';

const RecordClipTrigger = ({
  actions,
  isRecording,
  message,
  disableClassName,
  handleCancel,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.emptyScene}>
      {isRecording ? (
        <div>
          <p className={styles.tooltip}>{t('storyboard.editor.clip_status.recording')}</p>
          <CustomButton label={t('general.cancel')} onClick={handleCancel} variant="secondary" className={cx(styles.recordButton)} />
        </div>
      ) : (
        <>
          {message && (
            <p className={styles.tooltip}>
                {message}
            </p>
          )}
          <div className={styles.actionsWrapper}>
              {actions?.map(({ label, disabled, onClick, disabledTooltip = '' }, index) =>
                <TooltipButton
                  key={index}
                  label={label}
                  disabled={disabled}
                  onClick={(e) => { e.stopPropagation(); onClick(e); }}
                  variant="secondary"
                  hoverOnDisabled={Boolean(disabledTooltip)}
                  tooltipText={disabledTooltip}
                  className={cx(styles.recordButton, {
                    [disableClassName]: disabled,
                  })}
                  classNameTooltip={styles.btnTooltip}
                />)}
          </div>
        </>
      )}
    </div>
  );
};

export default RecordClipTrigger;
